
const GQL_DYSLEXIA_RISK_DATA = `
query ($input: ClassroomAmiraDyslexiaRiskInput!) {
  classroomDyslexiaRiskData(input: $input) {
    leaGroupId
    data {
      aggregateData {
        highCount
        lowCount
        moderateCount
      }
      students {
        id
        name
        riskLevel
      }
    }
  }
}
`;

export default GQL_DYSLEXIA_RISK_DATA;